<script lang="ts">
    import { messageInfo } from "../store";
    import Divider from "../components/Divider.svelte";
    import Submit from "../components/Submit.svelte";
    import ScanIMEI from "../components/ScanIMEI.svelte";

    let submit = null;

    const doneEvent = () => {
        submit.click();
    };
</script>

<main>
    <Divider>Capture numéro IMEI</Divider>
    <div class="scan">
        <ScanIMEI
            bind:serial={$messageInfo.imei}
            bind:img={$messageInfo.sticker}
            on:done={doneEvent}
        />
    </div>

    <!-- User button to skip page and type serial manually -->
    <Submit backButton bind:this={submit}>Passer</Submit>
</main>

<style>
    .scan {
        width: 100%;
        border: lightgrey 1px solid;
    }
</style>
